<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--8">
            <div class="card shadow">
                <div class="row p-3">
                    <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
                        <button :disabled="!showActionDelete" v-on:click="showConfirmationModal = true"
                            class="btn btn-danger">
                            <i class="fa fa-trash"></i> Delete
                        </button>
                        <button v-on:click="onEditRow" :disabled="!showActionEdit" class="btn btn-primary">
                            <i class="fa fa-edit"></i> Edit
                        </button>
                        <button v-on:click="onCreateUserTask" class="btn btn-primary">
                            Create User Task Rules
                        </button>
                    </div>
                    <div class="col-6 pull-right">
                        <div class="row">
                            <label class="col-4 col-form-label form-control-label text-right">
                                Brand
                            </label>
                            <div class="col-8">
                                <model-list-select :list="brandCodeOption"   v-model="watch_brand_code"
                                    option-value="value" option-text="text" placeholder="Select Brand">
                                </model-list-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="message">
                    <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{ message.message
                        }}</base-alert>
                </div>
                <div v-if="deleteMessages">
                    <base-alert :type="deleteMessages[0].type" :dismissible="true"
                        v-for="(row, index) in deleteMessages" :key="index">{{ row.message }}</base-alert>
                </div>
                <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes"
                    @on-select-row="onSelectRow" @on-unselect-row="onSelectRow"
                    @refresh-data="onRefreshData">
                    <template slot="is_giid_only_column" slot-scope="props">
                        <label v-if="props.cell_value == 0"> False </label>
                        <label v-if="props.cell_value == 1"> True </label>
                    </template>
                </vue-bootstrap4-table>
            </div>
        </div>
        <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
            <h3>Are you sure to delete these items?</h3>
            <ul>
                <li v-for="(row, index) in selectedItems" :key="index">
                    {{ row.task_rule_name }}
                </li>
            </ul>
            <template slot="footer">
                <div class="row">
                    <div class="col-lg-6">
                        <base-button type="link" class="ml-auto btn-block" @click="showConfirmationModal = false">No
                        </base-button>
                    </div>
                    <div class="col-lg-6">
                        <base-button type="primary" class="ml-auto btn-block" @click="onDeleteRow">Yes
                        </base-button>
                    </div>
                </div>
            </template>
        </modal>
        <modal :show.sync="showModalCreate" modal-classes="modal-lg">
            <h3 slot="header" class="modal-title" id="modal-title-default">
                {{ this.isEdit ? "Update" : "Create" }} User Task Rules Config
            </h3>
            <form @submit.prevent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <label class="form-control-label required"> Brand Code </label>
                            <model-list-select  :list="brandCodeOption" v-model="watch_brand_code" option-value="value"
                                option-text="text" placeholder="select item" :isDisabled="isBrandCodeDisabled">
                            </model-list-select>
                        </div>
                    </div>
                </div>
            
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <base-input alternative="" required label="Task Rules Name" input-classes="form-control"
                                v-model="UserTaskRulesConfigModel.task_rule_name"  />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group has-label">
                            <label class="form-control-label required"> Reason </label>
                            <model-list-select  :list="reasonOption" v-model="watch_reason" option-value="value"
                                option-text="text" placeholder="select item" >
                            </model-list-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <label class="form-control-label required"> Prize </label>
                        <multiselect v-model="MajorPrizeValue" tag-placeholder="Add this as Prize"
                            placeholder="Search or add Prize" label="prize_name" track-by="id" :options="prizeOption"
                            :multiple="true" :taggable="true">
                        </multiselect>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6"></div>
                </div>
                <br />
            </form>
            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="showModalCreate = false">Close/ Cancel
                </base-button>
                <button v-on:click="onSubmit" v-bind:disabled="disableButtonSubmit" class="btn btn-primary">
                    Submit
                </button>
            </template>
        </modal>
    </div>
</template>
<script>

import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";

export default {
    name: "UserTaskList",
    data() {
        return {
            files: [],
            is_allowed_create: false,
            watch_brand_code: "PHFortune",
            watch_reason: "",
            deleteMessages: [],
            MajorPrizeValue: [],
            reasonOption: [
                { text: "Reaction", value: "1" },
                { text: "Completed", value: "2" },
            ],
            showConfirmationModal: false,
            selectedItems: [],
            prizeOption: [],
            startEndDate: [],
            showActionEdit: false,
            showActionDelete: false,
            brandCodeOption: [],
            isEdit: false,
            titlePopup: "Create",
            message: null,
            UserTaskRulesConfigModel: {
                id: "",
                task_rule_name:"",
                brand_code: "",
                reason: "",
                prizes: []
            },
            showModalCreate: false,
            showModalDetail: false,
            rows: [],
            allTaskRules: [],
            columns: [
                {
                    label: "ID",
                    name: "id",
                    slot_name: "action_button",
                },  {
                    label: "Name",
                    name: "task_rule_name",
                    sort: true,
                },
                {
                    label: "Brand",
                    name: "brand_code",
                    sort: true,
                },
                {
                    label: "Reason",
                    name: "reason_name",
                    sort: true,
                },
                {
                    label: "Prize",
                    name: "prizes",

                    sort: true,
                },
            ],
            config: {
                pagination: true,
                pagination_info: true,
                num_of_visibile_pagination_buttons: 7,
                per_page: 10,
                checkbox_rows: true,
                highlight_row_hover: true,
                rows_selectable: true,
                multi_column_sort: false,
                card_mode: false,
                selected_rows_info: true,
                per_page_options: [5, 10, 20, 30],
            },
            classes: {
                table: "table-striped table-bordered",
                row: {
                    "my-row my-row2": true,
                    "function-class": function (row) {
                        return row.id == 1;
                    },
                },
            },
        };
    },
    created() {
        this.mappingRole();
        this.isBrandCodeDisabled = false;
        this.onRefreshData();
    },
    methods: {
        fetchUserTaskRules() {
            api_loyalty
            .GetAllUserTaskRulesConfig(this.watch_brand_code)
            .then((data) => {
                if(data.isSuccess){
                    data.data.forEach(function (item){
                        switch(item.reason){
                            case "1": item.reason_name = "Reaction"; break;
                            case "2": item.reason_name = "Completed"; break;
                        }
                    }); 
                    this.rows = data.data;
                    this.allTaskRules = data.data;
                }
            });
        },

        mappingRole() {
        let isChe = this.$store.getters.roleMappingData.some(object =>
            object.role.toLowerCase().includes('phche') &&
            object.menu.toLowerCase().includes('usertaskrulesconfig')
        );
        let isFortune = this.$store.getters.roleMappingData.some(object =>
            object.role.toLowerCase().includes('phft') ||
            object.role.toLowerCase().includes('fortune') &&
            object.menu.toLowerCase().includes('usertaskrulesconfig')
        );
        let isAdministrator = this.$store.getters.isLoginUserAdmin;
        this.brandCodeOption = [];
        if (isAdministrator || isChe) {

                this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
                this.watch_brand_code = this.UserTaskRulesConfigModel.brand_code =
                    "PHChe";
                this.is_allowed_create = true;
            }
            if (isAdministrator || isFortune) {

                this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
                this.watch_brand_code = this.UserTaskRulesConfigModel.brand_code =
                    "PHFortune";
                this.is_allowed_create = true;
            }
        },
        getPrizeOption() {
            api_loyalty
                .GetAllPrizeConfig(this.UserTaskRulesConfigModel.brand_code)
                .then((result) => {
                    if(result.isSuccess){
                        this.prizeOption = result.data;
                    }
                });
        },
        onChangeRangeDate(params) {
            this.UserTaskRulesConfigModel.start_date = new Date(
                params[0]
            ).toISOString();
            this.UserTaskRulesConfigModel.end_date = new Date(
                params[1]
            ).toISOString();
        },
        onSubmit() {
            if (this.isEdit) this.doUpdateUserTaskRules();
            else this.doCreateUserTaskRules();
        },
        resetMessage() {
            this.message = null;
            this.deleteMessages = [];
            this.selectedItems = [];
        },
        onResetForm() {
            this.UserTaskRulesConfigModel = {...this.UserTaskRulesConfigModel,
                brand_code: this.watch_brand_code,
                prizes: "",
                reason: "",
                task_rule_name:""
            };
            this.watch_reason = "";
            this.MajorPrizeValue = []
        },    onResetFormBrandCodeChange() {
            this.UserTaskRulesConfigModel = {...this.UserTaskRulesConfigModel,
                prizes: "",
            };
            this.MajorPrizeValue = []
        },
        doCreateUserTaskRules() {
            this.UserTaskRulesConfigModel.id = ""
            this.showModalCreate = false;
            api_loyalty
                .CreateUserTaskRulesConfig(this.UserTaskRulesConfigModel)
                .then((data) => {
                    if(data.isSuccess){
                        this.message = {
                            message: data.message,
                            type: "success",
                        };
                        this.onRefreshData();
                        this.onResetForm();
                    }
                })
                .catch((e) => {
                    this.message = {
                        message: e.message,
                        type: "danger",
                    };
                    this.onResetForm();
                });
        },
        doUpdateUserTaskRules() {
            this.showModalCreate = false;
            api_loyalty
                .UpdateUserTaskRulesConfig(this.UserTaskRulesConfigModel)
                .then((data) => {
                    if(data.isSuccess){
                        this.message = {
                            message: data.message,
                            type: "success",
                        };
                        this.onRefreshData();
                        this.onResetForm();
                    }
                })
                .catch((e) => {
                    this.message = {
                        message: e.message,
                        type: "danger",
                    };
                    this.onResetForm();
                });
        },
        onCreateUserTask() {
            this.showModalCreate = true;
            this.isBrandCodeDisabled = false;
            this.onResetForm()
            this.isEdit = false;

        },
        async onRefreshData() {
            this.fetchUserTaskRules();
            this.getPrizeOption();
        },
        onSelectRow(payload) {
            this.showActionEdit = true;
            this.showActionDelete = true;
            this.selectedItems = payload.selected_items;
            if (payload.selected_items.length == 0) {
                this.showActionEdit = false;
                this.showActionDelete = false;
            }
            if (payload.selected_items.length > 1) {
                this.showActionEdit = false;
            }
        },
        onEditRow() {
            this.isEdit = true;
            this.isBrandCodeDisabled = true;
            this.UserTaskRulesConfigModel = this.allTaskRules.filter(
                (x) => x.id === this.selectedItems[0].id
            )[0];

            let mapped = []
            this.UserTaskRulesConfigModel.prizes.forEach(element => {
                let idx = this.prizeOption.findIndex(x => x.id === element)
                if (idx > -1) mapped.push(this.prizeOption[idx])
            });
            this.MajorPrizeValue = mapped

            this.watch_reason = this.UserTaskRulesConfigModel.reason;
            this.showModalCreate = true;
        },
        onDeleteRow() {
            this.selectedItems.forEach((element) => {
                api_loyalty
                    .DeleteUserTaskRulesConfig(element)
                    .then((response) => {
                        var popupType = "success";
                        if (response.isSuccess == false) {
                            popupType = "danger";
                        }
                        this.onRefreshData();
                        let msg = {
                            message: response.message + " : " + element.task_rule_name + "'.",
                            type: popupType,
                        };
                        this.deleteMessages.push(msg);
                    })
                    .catch((e) => {
                        let msg = {
                            message: "Failed to delete User Task Rules '" + e.message + "'.",
                            type: "danger",
                        };
                        this.deleteMessages.push(msg);
                    });
            });
            this.showConfirmationModal = false;
        },
    },
    components: {
        VueBootstrap4Table,
        ModelListSelect,
        Multiselect
    },
    watch: {
        watch_brand_code: function () {
            this.UserTaskRulesConfigModel.brand_code = this.watch_brand_code;
            this.onResetFormBrandCodeChange()
            this.onRefreshData();
        },
        MajorPrizeValue: function (val) {
            let mappedOption = val.map(x => { return x.id })
            this.UserTaskRulesConfigModel.prizes = mappedOption
        },
        watch_reason:function (val){
            this.UserTaskRulesConfigModel.reason = val;
        }
    },
    computed: {
        disableButtonSubmit: function () {
            let isDisabled = false;
            if (
                this.UserTaskRulesConfigModel.task_rule_name &&
                this.UserTaskRulesConfigModel.brand_code &&
                this.UserTaskRulesConfigModel.reason &&
                this.UserTaskRulesConfigModel.prizes.length > 0 

            ) {
                isDisabled = false;
            } else {
                isDisabled = true;
            }
            return isDisabled;
        },
    },
};
</script>
<style scoped>
.preview {
    display: inline-block;
    margin: 5px;
}

.preview img {
    max-width: 100px;
    max-height: 100px;
    display: block;
}

.delete {
    background-color: red;
    color: white;
    border: none;
    cursor: pointer;
    display: block;
    margin-top: 5px;
}

#preview-container .preview {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
}

.img-thumbnail {
    width: 100px;
    height: auto;
}

.required::after {
  content: " *";
  color: red;
  font-weight: bold;
}
</style>
